import { computed } from "vue";
import { RouteLocationNormalized, useRoute } from "vue-router";
import { PrematchStaticCategories } from "../model/enums/prematch-static-categories";

export default function usePrematchRouteIds(r?: RouteLocationNormalized) {
    const route = r || useRoute();

    const getRouteIds = computed(() => {
        const [sportId = null, countryId = null] = (route?.params?.sportAndCountryId as string)?.split("-") || [];
        const leagueId = route?.params?.leagueId as string;
        const eventId = route?.params?.eventId as string;

        return { sportId, countryId, leagueId, eventId };
    });

    const isRouteStatic = computed(() => {
        const sportAndCountryId =
            typeof route?.params?.sportAndCountryId === "string" ? route?.params?.sportAndCountryId : null;
        return (
            [PrematchStaticCategories.FAVORITES, PrematchStaticCategories.MOST_POPULAR].includes(
                sportAndCountryId as PrematchStaticCategories,
            ) || route?.name === "Prematch"
        );
    });

    return { getRouteIds, isRouteStatic };
}
